import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/trader/Layout';
import Home from './pages/trader/Home';
import Login from './pages/trader/Login';
import Signup from './pages/trader/Signup';
import Dashboard from './pages/trader/Dashboard';
import WhatsAppLayout from './components/whatsappapi/Layout';
import WhatsappAppLayout from './components/whatsappapi/AppLayout';

import WhatsAppHome from './pages/whatsappapi/Home';
import WhatsappDashboard from './pages/whatsappapi/WhatsappDashboard';
import Message from './pages/whatsappapi/Message';
import Payment from './pages/whatsappapi/Payment';


import WhatsappapiLogin from './pages/whatsappapi/Login';
import WhatsappapiOrderStatus from './pages/whatsappapi/OrderStatus';
import WhatsappapiSignup from './pages/whatsappapi/Signup';

import KitstersLayout from './components/kitsters/Layout';
import KitstersAppLayout from './components/kitsters/AppLayout';

import KitstersLogin from './pages/kitsters/Login';
import KitstersDashboard from './pages/kitsters/Dashboard';

import AppointmentLayout from './components/appointment/Layout';
import AppointmentAppLayout  from './components/appointment/AppLayout';

import AppointmentHome from './pages/appointment/Home';
import Appointment from './pages/appointment/Appointment';

import AppointmentLogin from './pages/appointment/Login';
import AppointmentSignup from './pages/appointment/Signup';
import ProtectedRoute from './components/ProtectedRoute'; 

import AppointmentDummyPayment from './pages/appointment/DummyPayment';
import AppointmentPaymentUpdate from './pages/appointment/PaymentUpdate';
import PrescriptionAdmin from './pages/appointment/PrescriptionAdmin';
import AppointmentAdmin from './pages/appointment/AppointmentAdmin';
import PatientnAdmin from './pages/appointment/PatientAdmin';
import Prescription from './pages/appointment/Prescription';
import NoAuthPrescriptionView from './pages/appointment/NoAuthPrescriptionView';

const params = new URLSearchParams(window.location.search);
export let APPSETTING = localStorage.getItem('appsetting') ? JSON.parse(localStorage.getItem('appsetting') || "{}"): null;
//console.log("APPSETTING > ", APPSETTING);
if (!APPSETTING?.appname && !params.get("appname") && document.location.href.match(/senddit.in|ssl.itpatil.com/gi) ) {
  APPSETTING = {adminuserid:"6a043a73ef964e67e1c77ec0", appname:"whatsappapi"};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
} else if (params.get("appname")) {
  APPSETTING = {adminuserid:params.get("adminuserid"), appname:params.get("appname")};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
}
console.log(APPSETTING);
window.APPSETTING = APPSETTING;


const link = document.createElement('link');
link.rel = 'stylesheet';
let csshref = `/css/trader/style.css`;
document.head.appendChild(link);
let title = "Trader";
if (APPSETTING.appname == "kitsters") {
  csshref = csshref.replace("trader", "kitsters");
  title = "Kitsters Data App";
} else if (APPSETTING.appname == "whatsappapi") {
  csshref = csshref.replace("trader", "whatsappapi");
  title = "WhatsappApi";
} else if (APPSETTING.appname == "appointment") {
  csshref = csshref.replace("trader", "appointment");
  title = "Appointmet - devbranch V4";
}
link.href = csshref;
$(".pagetitle").html(title);

export const APPUSER = JSON.parse(localStorage.getItem(APPSETTING.appname + "user") || "{}");
window.APPUSER = APPUSER;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <Routes>
        {/* Trader App Routing */}
        {window.APPSETTING.appname === "trader" && (
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        )}
        
        {/* WhatsApp API App Routing */}
        {window.APPSETTING.appname === "whatsappapi" && (
          <Route path="/" element={<WhatsAppLayout />}>
            <Route index element={<WhatsAppHome />} />
            <Route path="/login" element={<WhatsappapiLogin />} />
            <Route path="/signup" element={<WhatsappapiSignup />} />
            <Route path="/orderstatus" element={<WhatsappapiOrderStatus />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<WhatsappAppLayout />}>
                <Route index element={<WhatsappDashboard />} />
              </Route>
              <Route path="/message" element={<WhatsappAppLayout />}>
                <Route index element={<Message />} />
              </Route>
              <Route path="/payment" element={<WhatsappAppLayout />}>
                <Route index element={<Payment />} />
              </Route>
            </Route>
          </Route>
        )}

        {/* Kitsters Routing */}
        {window.APPSETTING.appname === "kitsters" && (
          <Route path="/" element={<KitstersLayout />}>
            <Route path="/login" element={<KitstersLogin />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<KitstersAppLayout />}>
                <Route index element={<KitstersDashboard />} />
              </Route>
            </Route>
          </Route>
        )}


        {/* Appointment App Routing */}
        {window.APPSETTING.appname === "appointment" && (
          <>
            {/* Public Routes with standard Layout */}
            <Route path="/" element={<AppointmentLayout />}>
              <Route index element={<AppointmentHome />} />
              <Route path="/login" element={<AppointmentLogin />} />
              <Route path="/signup" element={<AppointmentSignup />} />
              <Route path="/prescriptionview" element={<NoAuthPrescriptionView />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<AppointmentAppLayout />}>
                <Route index element={<Appointment />} />
              </Route>
              <Route path="/prescriptionadmin" element={<AppointmentAppLayout />}>
                <Route index element={<PrescriptionAdmin />} />
              </Route>
              <Route path="/appointmentadmin" element={<AppointmentAppLayout />}>
                <Route index element={<AppointmentAdmin />} />
              </Route>
              <Route path="/prescription" element={<AppointmentAppLayout />}>
                <Route index element={<Prescription />} />
              </Route>
              <Route path="/patientadmin" element={<AppointmentAppLayout />}>
                <Route index element={<PatientnAdmin />} />
              </Route>
              <Route path="dummypayment" element={<AppointmentDummyPayment />} />
              <Route path="paymentupdate" element={<AppointmentPaymentUpdate />} />
            </Route>
          </>
        )}
      </Routes>
    </BrowserRouter>
)

// TypeScript Declaration (add to a d.ts file or top of file)
declare global {
  interface Window { APPSETTING: any; APPUSER:any;}
}


